import {useState, useEffect} from 'react';

import {useParams} from 'react-router';

import {getAccreditationBody} from 'api/accreditation-bodies';
import {alertByError} from 'utils/alerts';

const useGetAB = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const {abId} = useParams();

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setIsLoading(true);
    try {
      const {data} = await getAccreditationBody(abId);

      setData(data);
    } catch (error) {
      alertByError(error);
    } finally {
      setIsLoading(false);
    }
  };

  return {isLoading, data};
};

export default useGetAB;
